var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('p',{staticClass:"m-0 p-0"},[_vm._v(_vm._s(_vm.cruise))]),_c('p',{staticClass:"float-end text-muted m-0 p-0",staticStyle:{"font-size":"10px"}},[_vm._v(" "+_vm._s(_vm.dete)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }